var map = {
	"./KECC/AboutUs/AboutESG/lang/en-us.json": "./src/components/DefaultHome/KECC/AboutUs/AboutESG/lang/en-us.json",
	"./KECC/AboutUs/AboutKEC/lang/en-us.json": "./src/components/DefaultHome/KECC/AboutUs/AboutKEC/lang/en-us.json",
	"./KECC/AboutUs/ContactUs/lang/en-us.json": "./src/components/DefaultHome/KECC/AboutUs/ContactUs/lang/en-us.json",
	"./KECC/AboutUs/JoinUs/lang/en-us.json": "./src/components/DefaultHome/KECC/AboutUs/JoinUs/lang/en-us.json",
	"./KECC/AboutUs/Team/lang/en-us.json": "./src/components/DefaultHome/KECC/AboutUs/Team/lang/en-us.json",
	"./KECC/Common/lang/en-us.json": "./src/components/DefaultHome/KECC/Common/lang/en-us.json",
	"./KECC/Declare/Privacy/lang/en-us.json": "./src/components/DefaultHome/KECC/Declare/Privacy/lang/en-us.json",
	"./KECC/Declare/Terms/lang/en-us.json": "./src/components/DefaultHome/KECC/Declare/Terms/lang/en-us.json",
	"./KECC/Home/lang/en-us.json": "./src/components/DefaultHome/KECC/Home/lang/en-us.json",
	"./KECC/Organizers/Album/lang/en-us.json": "./src/components/DefaultHome/KECC/Organizers/Album/lang/en-us.json",
	"./KECC/Organizers/AlbumPhoto/lang/en-us.json": "./src/components/DefaultHome/KECC/Organizers/AlbumPhoto/lang/en-us.json",
	"./KECC/Organizers/Exhibition/lang/en-us.json": "./src/components/DefaultHome/KECC/Organizers/Exhibition/lang/en-us.json",
	"./KECC/Organizers/Facility/lang/en-us.json": "./src/components/DefaultHome/KECC/Organizers/Facility/lang/en-us.json",
	"./KECC/Organizers/RentalVenue/lang/en-us.json": "./src/components/DefaultHome/KECC/Organizers/RentalVenue/lang/en-us.json",
	"./KECC/Organizers/RentalVenueSpace/lang/en-us.json": "./src/components/DefaultHome/KECC/Organizers/RentalVenueSpace/lang/en-us.json",
	"./KECC/Press/Document/lang/en-us.json": "./src/components/DefaultHome/KECC/Press/Document/lang/en-us.json",
	"./KECC/Press/News/lang/en-us.json": "./src/components/DefaultHome/KECC/Press/News/lang/en-us.json",
	"./KECC/Press/Video/lang/en-us.json": "./src/components/DefaultHome/KECC/Press/Video/lang/en-us.json",
	"./KECC/Visitors/Accommodation/lang/en-us.json": "./src/components/DefaultHome/KECC/Visitors/Accommodation/lang/en-us.json",
	"./KECC/Visitors/ExhibitionPage/lang/en-us.json": "./src/components/DefaultHome/KECC/Visitors/ExhibitionPage/lang/en-us.json",
	"./KECC/Visitors/Traffic/lang/en-us.json": "./src/components/DefaultHome/KECC/Visitors/Traffic/lang/en-us.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/DefaultHome sync recursive ^\\.\\/KECC.*\\/lang\\/en\\-us\\.json$";